import type { Language } from '../common/enums/language';
import type { PowerduckStateInitArgs } from './powerduck-state';
import type { IPowerduckSystemResources } from './powerduck-system-resources';
import StorageProvider from '../common/local-storage-shim';
import { isNullOrEmpty } from '../common/utils/is-null-or-empty';
import { LanguageUtils } from '../common/utils/language-utils';
import TemporalUtils from '../common/utils/temporal-utils';
import { globalState } from './global-state';
import PowerduckState from './powerduck-state';

export interface PoweduckInitFrameworkArgs {
	supportedLanguages?: Language[];
}

export default class PowerduckInitializer {
	static initFramework(args?: PoweduckInitFrameworkArgs) {
		if (globalState.__viteErrHandlerBound != true) {
			globalState.__viteErrHandlerBound = true;

			globalState.addEventListener('vite:preloadError', (_event) => {
				const key = `${PowerduckState.getAppPrefix()}errLastReload`;
				const lastTry = Number(StorageProvider.getString(key) || '0');
				if (TemporalUtils.dateNowMs() - lastTry > 3000) {
					StorageProvider.setString(key, TemporalUtils.dateNowMs().toString());

					if (globalState.__routerNextTo != null && !isNullOrEmpty(globalState.__routerNextTo.path)) {
						location.href = globalState.__routerNextTo.path;
					} else {
						location.reload();
					}
				}
			});
		}

		if (args != null) {
			if (args.supportedLanguages?.length as number > 0) {
				LanguageUtils.supportedLanguages = args.supportedLanguages as Language[];
			}
		}
	}

	static initState<TResoures extends IPowerduckSystemResources>(resources: TResoures, args?: PowerduckStateInitArgs) {
		PowerduckState.initialize(resources, args);
	}
}
